import React from 'react'
import { getOperatorsForType } from '../../../utils/filters/filterOperators'

const FilterOperatorSelect = ({ fieldType, value, onChange }) => {
    const operators = getOperatorsForType(fieldType)

    return (
        <div className="select is-small is-fullwidth filterOperatorSelect">
            <select value={value} onChange={(e) => onChange(e.target.value)}>
                {operators.map((op) => (
                    <option key={op.key} value={op.key}>
                        {op.label}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default FilterOperatorSelect
